var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4913 1.16582C18.6359 1.51525 18.5764 1.81354 18.3125 2.0607L12.0191 8.36326V17.8491C12.0191 18.207 11.8532 18.4584 11.5212 18.6033C11.4106 18.6459 11.3042 18.6672 11.2021 18.6672C10.9723 18.6672 10.7808 18.5863 10.6277 18.4243L7.35967 15.1516C7.19797 14.9897 7.11712 14.7979 7.11712 14.5763V8.36326L0.823693 2.0607C0.559871 1.81354 0.500298 1.51525 0.644975 1.16582C0.789651 0.83343 1.04071 0.667236 1.39814 0.667236H17.7381C18.0955 0.667236 18.3466 0.83343 18.4913 1.16582Z",
    fill: "#7B73A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.a5db5ff2b4b30642dd5af0b6d719a238.svg";
export { ForwardRef as ReactComponent };